import { ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

interface UETWindow extends globalThis.Window {
  uet_report_conversion?: () => void
}

interface UmamiWindow extends globalThis.Window {
  umami?: { track: (eventName: string, data?: Record<string, unknown>) => void }
}

export function handleUETClick(): void {
  const win = typeof window !== 'undefined' ? (window as UETWindow) : undefined
  win?.uet_report_conversion?.()
}

export function trackEvent(eventName: string, eventData?: Record<string, unknown>): void {
  const win = typeof window !== 'undefined' ? (window as UmamiWindow) : undefined
  win?.umami?.track(eventName, eventData)
}

/**
 * 根布局里 Umami 是异步注入的，首屏 client effect 往往早于 `window.umami` 就绪。
 * 需要“曝光类”埋点时，用此 helper 在 umami 可用后再 `track`，返回的函数用于 effect cleanup。
 */
export function whenUmamiReady(onReady: () => void): () => void {
  if (typeof window === 'undefined') return () => {}

  const tryRun = (): boolean => {
    const w = window as UmamiWindow
    if (w.umami?.track) {
      onReady()
      return true
    }
    return false
  }

  if (tryRun()) return () => {}

  let attempts = 0
  const maxAttempts = 100
  const id = window.setInterval(() => {
    attempts++
    if (tryRun() || attempts >= maxAttempts) {
      window.clearInterval(id)
    }
  }, 100)

  return () => {
    window.clearInterval(id)
  }
}
